export interface ConsentPolicy {
  essential: boolean
  functional: boolean
  analytics: boolean
  advertising: boolean
  dataToThirdParty: boolean
}

export interface PolicyDetails {
  defaultPolicy: boolean
  policy?: ConsentPolicy
}

export interface ConsentPolicyManagerInterface {
  getCurrentConsentPolicy: GetCurrentConsentPolicy
  setConsentPolicy: SetConsentPolicy
  listConsentPolicies: any
  getConsentPolicy: any
  resetPolicy: any
}

export const DEFAULT_POLICY: ConsentPolicy = {
  essential: true,
  functional: true,
  analytics: true,
  advertising: true,
  dataToThirdParty: true,
}
export const WIX_EU_POLICY = {
  essential: true,
  functional: true,
  analytics: true,
  advertising: false,
  dataToThirdParty: false,
}

type PolicySuccessCallback = (policy: ConsentPolicy) => void
type PolicyErrorCallback = (error: Error) => void
type GetCurrentConsentPolicy = () => PolicyDetails
type SetConsentPolicy = (
  newPolicy: ConsentPolicy,
  successCallback?: PolicySuccessCallback,
  errorCallback?: PolicyErrorCallback,
) => void
